import { Component } from '@angular/core';

@Component({
  selector: 'icon-plane',
  templateUrl: './icon-plane.component.html',
  styleUrls: ['./icon-plane.component.sass']
})
export class IconPlaneComponent {}
